import { DataStreamVisualisation } from 'dashboard-engine/types/Visualisation';
import { DataStreamBarChartConfig } from './Config';
import BarChart from './visComponents/BarChart';

export const DataStreamBarChart: DataStreamVisualisation<DataStreamBarChartConfig> = (props) => {
    return <BarChart {...props} />;
};
